import { Iframe } from "./Iframe";
import { Tab } from "./sample/Tab";

export const Tickets = () => {
  return (
    <Tab>
      <Iframe url="tickets-employee" />
    </Tab>
  );
};
